import { gql } from '@apollo/client';

export const GET_APP_SETTINGS_QUERY = gql`
  query getAppSettings($input: GetAppSettingsInput!) {
    getAppSettings(input: $input) {
      id
      settingsTab
      settingsJson
      createdAt
      updatedAt
    }
  }
`;
